import { AfterViewInit, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-item-details-tabs',
  standalone: true,
  imports: [
    MatTabsModule,
    TranslateModule
  ],
  templateUrl: './item-details-tabs.component.html',
  styleUrl: './item-details-tabs.component.scss'
})
export class ItemDetailsTabsComponent implements AfterViewInit {

  @Output() tabPanelChange = new EventEmitter<string>();
  tabIndex = 0;

  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;

  ngAfterViewInit(): void {
    if(this.tabGroup) {
      const activeTab = this.tabGroup._tabs.toArray()[this.tabIndex];
      if (activeTab) {
        this.tabPanelChange.emit(activeTab.textLabel);
      }
    }
  }

}
